import { render, staticRenderFns } from "./modifyGroup.vue?vue&type=template&id=6a0923c2&scoped=true&"
import script from "./modifyGroup.vue?vue&type=script&lang=js&"
export * from "./modifyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0923c2",
  null
  
)

export default component.exports